const FOOT_COLS = [
  {
    title: "检索方式",
    links: ["按人物找", "按事件找", "按时间找", "黑料目录", "标签库"],
  },
  {
    title: "热门分区",
    links: ["今日热榜", "飙升关键词", "精选话题", "人物档案库", "年度复盘"],
  },
  {
    title: "找瓜指南",
    links: ["三步定向找瓜", "怎么选关键词", "如何辨瓜", "热度排序说明", "内容规范"],
  },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          <div>
            <a href="#search" className="inline-flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-focus-2-line text-lg" />
              </span>
              看料站
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              看料站黑料关键词检索，目录清晰、标签精准。按人物 / 事件 / 时间检索，定向找瓜不迷路。
            </p>
            <p className="mt-5 text-xs text-foreground-500">
              本站为产品演示页，页面人物、事件与热度数据均为虚构内容，仅用于界面展示。
            </p>
          </div>

          {FOOT_COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#search" className="text-sm text-foreground-600 transition hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 看料站 · 黑料关键词检索 | 看料站黑料目录标签 · 看料站定向找瓜查询搜索
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#search" className="whitespace-nowrap hover:text-foreground-900">
              用户须知
            </a>
            <a href="#search" className="whitespace-nowrap hover:text-foreground-900">
              联系反馈
            </a>
            <a href="#search" className="whitespace-nowrap hover:text-foreground-900">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}